// extracted by mini-css-extract-plugin
export default {"content":"content-module__content__cRfGb"};